module.exports = __webpack_public_path__ + "img/icons-8.b695f830.png";